// import React, { useState, useEffect, useCallback } from "react";
// import { Table, Button, Modal, Form } from "react-bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";
// import { IoTrashOutline } from "react-icons/io5";
// import axios from "../../../helper/axios";
// import { useUser } from "../../../Provider";
// import { Helmet } from "react-helmet";
// import { NavLink, useHistory } from "react-router-dom";
// import MUIDataTable from "mui-datatables";
// import IconButton from '@mui/material/IconButton';
// import DeleteIcon from '@mui/icons-material/Delete';
// import { FixedSizeList as List } from 'react-window';
// import AutoSizer from 'react-virtualized-auto-sizer';

// const ListViewBed = () => {
//   const {user, userHospitalcode, userrole1, isAuthRole,isAuthorized,gettokenId,token  } = useUser();
//   console.log(user, userHospitalcode, userrole1, isAuthRole,isAuthorized,gettokenId )
//   const history = useHistory();
//   const [data, setData] = useState([]);
//   const currentDate = new Date();
//   const day = currentDate.getDate();
//   const month = currentDate.getMonth() + 1; // Months are zero-indexed, so add 1
//   const year = currentDate.getFullYear();
//   const [totalCount, setTotalCount] = useState(0);
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [searchText, setSearchText] = useState("");

//   // Format the date as DD-MM-YYYY
//   const formattedDate = `${day}-${month}-${year}`;
//   //const token = sessionStorage.getItem("jwtToken");
//   const [userRole, setRole] = useState();

// // const fetchData = useCallback(async () => {
// //   try {
// //     const response = await axios.get("/GetPatients", {
// //       headers: { Authorization: `Bearer ${token}` },
// //       params: {
// //         hospitalcode: userHospitalcode,
// //         userrole: userrole1,
// //         page,
// //         limit: rowsPerPage,
// //       },
// //     });
// //     setData(response.data.patients);
// //     setTotalCount(response.data.totalCount);
// //   } catch (error) {
// //     console.error("Error fetching patient data:", error);
// //   }
// // }, [userHospitalcode, userrole1, token, page, rowsPerPage]);

// const fetchData = useCallback(async () => {
//   try {
//     const response = await axios.get("/GetPatients", {
//       headers: { Authorization: `Bearer ${token}` },
//       params: {
//         hospitalcode: userHospitalcode,
//         userrole: userrole1,
//         page,
//         limit: rowsPerPage,
//         search: searchText, // <-- send search text
//       },
//     });
//     setData(response.data.patients);
//     setTotalCount(response.data.totalCount);
//   } catch (error) {
//     console.error("Error fetching patient data:", error);
//   }
// }, [userHospitalcode, userrole1, token, page, rowsPerPage, searchText]);

// useEffect(() => {
//   fetchData();
// }, [fetchData]);

// const handlePageChange = (newPage) => {
//   setPage(newPage);
// };

// const handleRowsPerPageChange = (event) => {
//   const newLimit = typeof event === 'number' ? event : parseInt(event.target.value, 10);
//   setRowsPerPage(newLimit);
//   setPage(0); // Reset to first page on rowsPerPage change
// };

//   const cancelPatientdetails = async (patientid) => {
//     // Display a confirmation dialog
//     const isConfirmed = window.confirm("Do you want to delete this patient?");

//     if (isConfirmed) {
//       try {
//         console.log(patientid);
//         await axios.post(`/deletepatient/${patientid}`,null,  {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         });
//         // After successfully canceling the bill, refresh the bill list.
//         fetchData();
//       } catch (error) {
//         // Handle any error here.
//        alert("Error deleteing hospital:", error);
//       }
//     } else {
//       // User clicked "Cancel" in the confirmation dialog, do nothing.
//     }
//   };
//   let columns;
//   if (isAuthorized) {
//    columns = [
//     {
//      name: "patientid",
//      label: "Patient id",
//      options: {
//       filter: true,
//       sort: true,
//      }
//     },
//     {
//      name: "patientname",
//      label: "Patient Name",
//      options: {
//       filter: true,
//       sort: true,

//      customBodyRender: (value, tableMeta) => {
//       // Assuming the patient id is also available in your data
//       const patientid = tableMeta.rowData[0]; // Adjust this index as needed

//       return (
//         <NavLink to={`/listviewpatients/${patientid}`} className="addlink">{value}</NavLink>
//        );
//       }
//      }
//     },
//     // {
//     //  name: "gaurdianname",
//     //  label: "Guardian Name",
//     //  options: {
//     //   filter: true,
//     //   sort: true
//     //  }
//     // },
//     {
//      name: "phoneno",
//      label: "Mobile No",
//      options: {
//       filter: true,
//       sort: true,
//      }
//     },
//     {
//      name: "address",
//      label: "Address",
//      options: {
//       filter: true,
//       sort: true,
//      }
//     },
//     // {
//     //  name: "bloodgroup",
//     //  label: "Blood Group",
//     //  options: {
//     //   filter: true,
//     //   sort: true,
//     //   }
//     // },
//     {
//       name: "hospitalcode",
//       label: "Hospital Code",
//       options: {
//        filter: true,
//        sort: true,
//        customBodyRender: (value) => (value !== null && value !== undefined) ? value.toString().padStart(5, '0') : ""
//       }
//      },
//      {
//       name: "",
//       label: "Action",
//       options: {
//         customBodyRender: (value, tableMeta, updateValue) => {
//           const newD = data.find((e) => {
//             return (
//               e.patientid === tableMeta.rowData[0] &&
//               e.patientname === tableMeta.rowData[1] &&
//               // e.gaurdianname === tableMeta.rowData[2] &&
//               e.phoneno ===  tableMeta.rowData[2] &&
//               e.address === tableMeta.rowData[3] &&
//               // e.bloodgroup === tableMeta.rowData[5]&&
//               e.hospitalcode === tableMeta.rowData[4]
//             );
//           });
//           console.log('newD:', newD);
//           return (
//             <>
//               {/* <button
//               className="btn btn-danger btn-sm"
//               onClick={() => cancelPatientdetails(newD.patientid)}
//                       >
//                 Delete
//             </button> */}
//             <IconButton color="secondary"  onClick={() => cancelPatientdetails(newD.patientid)}>
//                           <DeleteIcon />
//                         </IconButton>
//             </>
//           );
//         },
//       },
//     },
//    ];

//   }
//   else{
//     columns = [
//       {
//        name: "patientid",
//        label: "Patient id",
//        options: {
//         filter: true,
//         sort: true,
//        }
//       },
//       {
//        name: "patientname",
//        label: "Patient Name",
//        options: {
//         filter: true,
//         sort: true,

//        customBodyRender: (value, tableMeta) => {
//         // Assuming the patient id is also available in your data
//         const patientid = tableMeta.rowData[0]; // Adjust this index as needed

//         return (
//           <NavLink to={`/listviewpatients/${patientid}`} className="addlink">{value}</NavLink>
//          );
//         }
//        }
//       },
//       // {
//       //  name: "gaurdianname",
//       //  label: "Guardian Name",
//       //  options: {
//       //   filter: true,
//       //   sort: true
//       //  }
//       // },
//       {
//        name: "phoneno",
//        label: "Mobile No",
//        options: {
//         filter: true,
//         sort: true,
//        }
//       },
//       {
//        name: "address",
//        label: "Address",
//        options: {
//         filter: true,
//         sort: true,
//        }
//       },
//       // {
//       //  name: "bloodgroup",
//       //  label: "Blood Group",
//       //  options: {
//       //   filter: true,
//       //   sort: true,
//       //   }
//       // },
//       {
//         name: "",
//         label: "Action",
//         options: {
//           customBodyRender: (value, tableMeta, updateValue) => {
//             const newD = data.find((e) => {
//               return (
//                 e.patientid === tableMeta.rowData[0] &&
//               e.patientname === tableMeta.rowData[1] &&
//             //  e.gaurdianname === tableMeta.rowData[2] &&
//               e.phoneno ===  tableMeta.rowData[2] &&
//             //  e.address === tableMeta.rowData[4] &&
//               e.bloodgroup === tableMeta.rowData[3]
//               );
//             });
//             console.log('newD:', newD);
//             return (
//               <>
//                 {/* <button
//                 className="btn btn-danger btn-sm"
//                 onClick={() => cancelPatientdetails(newD.patientid)}
//                         >
//                   Delete
//               </button> */}
//                <IconButton color="secondary"  onClick={() => cancelPatientdetails(newD.patientid)}>
//                           <DeleteIcon />
//                         </IconButton>
//               </>
//             );
//           },
//         },
//       },
//      ];
//   }

//   // const options = {
//   //   serverSide: true, // <--- This is key!
//   //   count: totalCount, // <--- Total number of records (from backend)
//   //   page: page, // <--- Current page
//   //   rowsPerPage: rowsPerPage, // <--- Current rows per page
//   //   onTableChange: (action, tableState) => {
//   //     if (action === 'changePage') {
//   //       handlePageChange(tableState.page);
//   //     } else if (action === 'changeRowsPerPage') {
//   //       handleRowsPerPageChange({ target: { value: tableState.rowsPerPage } });
//   //     }
//   //   },
//   //   selectableRows: false,
//   //   downloadOptions: {
//   //     filename: `Patient_list_${formattedDate}`,
//   //     filterOptions: {
//   //       useDisplayedColumnsOnly: true,
//   //       useDisplayedRowsOnly: true,
//   //     },
//   //   },
//   // };

//   const options = {
//     serverSide: true,
//     count: totalCount,
//     page: page,
//     rowsPerPage: rowsPerPage,
//     searchText: searchText,
//     onSearchChange: (searchText) => {
//       setSearchText(searchText);
//       setPage(0); // Reset to first page on new search
//     },
//     onTableChange: (action, tableState) => {
//       if (action === 'changePage') {
//         handlePageChange(tableState.page);
//       } else if (action === 'changeRowsPerPage') {
//         handleRowsPerPageChange({ target: { value: tableState.rowsPerPage } });
//       }
//     },
//     selectableRows: false,
//   };

//   //  const options = {
//   //   selectableRows: false,
//   //   onRowClick: ((props) => {
//   //     console.log(props)
//   //   })
//   // };
//   const currentDomain = window.location.hostname;
//   return (

//     <>
//      <Helmet>
//         <title>Patient Records System | {currentDomain} | Hospital Management Software | Smart Solutions for Hospital Efficiency </title>
//       </Helmet>
//        <NavLink to='/newpatientregistration'><button className="btn btn-success btn-sm mr-2" style={{margin: "10px"}}>  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" style={{ paddingRight: '4px' }} viewBox="0 0 100 100">
//         <line x1="10" y1="50" x2="90" y2="50" stroke="white" stroke-width="10" />
//         <line x1="50" y1="10" x2="50" y2="90" stroke="white" stroke-width="10" />
//       </svg>New Patient</button></NavLink>
//        <MUIDataTable
//         title={"Patient List"}
//         data={data}
//         columns={columns}
//         options={options}
//         className="custom-mui-datatable"
//       />
//     </>

//   );
// };

// export default ListViewBed;

import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Table, Button, Modal, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { IoTrashOutline } from "react-icons/io5";
import axios from "../../../helper/axios";
import { useUser } from "../../../Provider";
import { useToast } from "../../ToastSystem";
import { useConfirmation } from "../../ConfirmationModal";
import { Helmet } from "react-helmet";
import { NavLink, useHistory } from "react-router-dom";
import MUIDataTable from "mui-datatables";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import PrintIcon from "@mui/icons-material/Print";
import GetAppIcon from "@mui/icons-material/GetApp";

const ListViewBed = () => {
  const {
    user,
    userHospitalcode,
    userrole1,
    isAuthRole,
    isAuthorized,
    gettokenId,
    token,
  } = useUser();
  const { showSuccess, showError, showWarning, showInfo } = useToast();
  const { showConfirmation } = useConfirmation();

  console.log(
    user,
    userHospitalcode,
    userrole1,
    isAuthRole,
    isAuthorized,
    gettokenId
  );
  const history = useHistory();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [statusFilter, setStatusFilter] = useState("All");

  const currentDate = new Date();
  const day = currentDate.getDate();
  const month = currentDate.getMonth() + 1;
  const year = currentDate.getFullYear();
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchText, setSearchText] = useState("");

  const formattedDate = `${day}-${month}-${year}`;
  const [userRole, setRole] = useState();

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get("/GetPatients", {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          hospitalcode: userHospitalcode,
          userrole: userrole1,
          page,
          limit: rowsPerPage,
          search: searchText,
        },
      });
      setData(response.data.patients);
      setTotalCount(response.data.totalCount);
    } catch (error) {
      console.error("Error fetching patient data:", error);

      if (error.response) {
        if (error.response.status === 404) {
          showWarning("No patients found in the system.");
        } else if (error.response.status === 500) {
          showError("Server error. Please try again later.");
        } else {
          // showError("Failed to load patients. Please refresh the page.");
        }
      } else if (error.request) {
        showError("Network error. Please check your connection.");
      } else {
        showError("Error loading patient data.");
      }
    } finally {
      setLoading(false);
    }
  }, [userHospitalcode, userrole1, token, page, rowsPerPage, searchText]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    const newLimit =
      typeof event === "number" ? event : parseInt(event.target.value, 10);
    setRowsPerPage(newLimit);
    setPage(0);
  };

  // Filter data based on status
  const filteredData = useMemo(() => {
    if (statusFilter === "All") {
      return data;
    }
    return data.filter((patient) => patient.status === statusFilter);
  }, [data, statusFilter]);

  // CSV Download Handler
  const handleDownloadCSV = useCallback(() => {
    try {
      if (filteredData.length === 0) {
        showError("No patients available to download!");
        return;
      }

      const headers = isAuthorized
        ? [
            "Patient ID",
            "Patient Name",
            "Mobile No",
            "Address",
            "Hospital Code",
          ]
        : ["Patient ID", "Patient Name", "Mobile No", "Address"];

      const rows = filteredData.map((patient) =>
        isAuthorized
          ? [
              patient.patientid,
              patient.patientname,
              patient.phoneno,
              patient.address,
              patient.hospitalcode?.toString().padStart(5, "0") || "",
            ]
          : [
              patient.patientid,
              patient.patientname,
              patient.phoneno,
              patient.address,
            ]
      );

      const csvContent =
        "data:text/csv;charset=utf-8," +
        [headers.join(","), ...rows.map((r) => r.join(","))].join("\n");

      const link = document.createElement("a");
      link.href = encodeURI(csvContent);
      link.download = `Patient_list_${formattedDate}.csv`;
      link.click();

      showSuccess(
        `Successfully downloaded ${filteredData.length} patient records!`
      );
    } catch (error) {
      console.error("CSV download error:", error);
      showError("Failed to download patient list. Please try again.");
    }
  }, [filteredData, formattedDate, isAuthorized, showSuccess, showError]);

  // Print Handler
  const handlePrint = useCallback(() => {
    try {
      if (filteredData.length === 0) {
        showError("No patients available to print!");
        return;
      }

      const now = new Date();
      const printDate = now.toLocaleDateString("en-IN");
      const printTime = now.toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
      });

      const printableHTML = `
        <html>
          <head>
            <title>Patient List Report</title>
            <style>
              body {
                font-family: Arial, sans-serif;
                margin: 30px;
                color: #000;
              }
              h2 {
                text-align: center;
                margin-bottom: 10px;
                text-transform: uppercase;
              }
              .header {
                display: flex;
                justify-content: space-between;
                font-size: 14px;
                margin-bottom: 20px;
              }
              table {
                width: 100%;
                border-collapse: collapse;
                font-size: 14px;
              }
              th, td {
                border: 1px solid #333;
                padding: 8px;
                text-align: left;
              }
              th {
                background-color: #f2f2f2;
                text-transform: uppercase;
              }
              tr:nth-child(even) {
                background-color: #fafafa;
              }
              @media print {
                body { margin: 0; }
              }
            </style>
          </head>
          <body>
            <h2>Patient List Report</h2>
            <div class="header">
              <div><strong>Date:</strong> ${printDate}</div>
              <div><strong>Time:</strong> ${printTime}</div>
            </div>
            <table>
              <thead>
                <tr>
                  <th>Patient ID</th>
                  <th>Patient Name</th>
                  <th>Mobile No</th>
                  <th>Address</th>
                  ${isAuthorized ? "<th>Hospital Code</th>" : ""}
                </tr>
              </thead>
              <tbody>
                ${filteredData
                  .map(
                    (patient) => `
                  <tr>
                    <td>${patient.patientid || ""}</td>
                    <td>${patient.patientname || ""}</td>
                    <td>${patient.phoneno || ""}</td>
                    <td>${patient.address || ""}</td>
                    ${
                      isAuthorized
                        ? `<td>${
                            patient.hospitalcode?.toString().padStart(5, "0") ||
                            ""
                          }</td>`
                        : ""
                    }
                  </tr>`
                  )
                  .join("")}
              </tbody>
            </table>
          </body>
        </html>
      `;

      const win = window.open("", "_blank");
      win.document.write(printableHTML);
      win.document.close();
      win.focus();
      win.print();
      win.close();

      showSuccess(
        `Successfully sent ${filteredData.length} patient records to printer!`
      );
    } catch (error) {
      console.error("Print error:", error);
      showError("Failed to print patient list. Please try again.");
    }
  }, [filteredData, isAuthorized, showSuccess, showError]);

  // Delete Patient Handler with Confirmation
  const cancelPatientdetails = async (patientid, patientname) => {
    try {
      const confirmed = await showConfirmation({
        title: "Delete Patient",
        message: `Are you sure you want to delete patient "${patientname}" (ID: ${patientid})? This action cannot be undone.`,
        confirmText: "Delete",
        cancelText: "Cancel",
        type: "danger",
      });

      if (!confirmed) return;

      const response = await axios.post(`/deletepatient/${patientid}`, null, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        showSuccess(`Patient "${patientname}" has been successfully deleted!`);
        await fetchData();
      }
    } catch (error) {
      console.error("Error deleting patient:", error);

      if (error.response) {
        if (error.response.status === 404) {
          showError("Patient not found. It may have already been deleted.");
        } else if (error.response.status === 409) {
          showWarning(
            "Cannot delete patient. They may have active appointments or records."
          );
        } else if (error.response.status === 403) {
          showError("You don't have permission to delete this patient.");
        } else if (error.response.status === 500) {
          showError("Server error. Please try again later.");
        } else {
          showError("Failed to delete patient. Please try again.");
        }
      } else if (error.request) {
        showError("Network error. Please check your connection.");
      } else {
        showError("Error deleting patient.");
      }

      await fetchData();
    }
  };

  let columns;
  if (isAuthorized) {
    columns = [
      {
        name: "patientid",
        label: "Patient ID",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "patientname",
        label: "Patient Name",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta) => {
            const patientid = tableMeta.rowData[0];
            return (
              <NavLink
                to={`/listviewpatients/${patientid}`}
                className="addlink"
              >
                {value}
              </NavLink>
            );
          },
        },
      },
      {
        name: "phoneno",
        label: "Mobile No",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "address",
        label: "Address",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "hospitalcode",
        label: "Hospital Code",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) =>
            value !== null && value !== undefined
              ? value.toString().padStart(5, "0")
              : "",
        },
      },
      {
        name: "",
        label: "Action",
        options: {
          customBodyRender: (value, tableMeta, updateValue) => {
            const newD = data.find((e) => {
              return (
                e.patientid === tableMeta.rowData[0] &&
                e.patientname === tableMeta.rowData[1] &&
                e.phoneno === tableMeta.rowData[2] &&
                e.address === tableMeta.rowData[3] &&
                e.hospitalcode === tableMeta.rowData[4]
              );
            });
            return (
              <>
                <IconButton
                  color="secondary"
                  onClick={() =>
                    cancelPatientdetails(newD.patientid, newD.patientname)
                  }
                >
                  <DeleteIcon />
                </IconButton>
              </>
            );
          },
        },
      },
    ];
  } else {
    columns = [
      {
        name: "patientid",
        label: "Patient ID",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "patientname",
        label: "Patient Name",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta) => {
            const patientid = tableMeta.rowData[0];
            return (
              <NavLink
                to={`/listviewpatients/${patientid}`}
                className="addlink"
              >
                {value}
              </NavLink>
            );
          },
        },
      },
      {
        name: "phoneno",
        label: "Mobile No",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "address",
        label: "Address",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "",
        label: "Action",
        options: {
          customBodyRender: (value, tableMeta, updateValue) => {
            const newD = data.find((e) => {
              return (
                e.patientid === tableMeta.rowData[0] &&
                e.patientname === tableMeta.rowData[1] &&
                e.phoneno === tableMeta.rowData[2] &&
                e.address === tableMeta.rowData[3]
              );
            });
            return (
              <>
                <IconButton
                  color="secondary"
                  onClick={() =>
                    cancelPatientdetails(newD.patientid, newD.patientname)
                  }
                >
                  <DeleteIcon />
                </IconButton>
              </>
            );
          },
        },
      },
    ];
  }

  const options = {
    serverSide: true,
    count: totalCount,
    page: page,
    rowsPerPage: rowsPerPage,
    searchText: searchText,
    onSearchChange: (searchText) => {
      setSearchText(searchText);
      setPage(0);
    },
    onTableChange: (action, tableState) => {
      if (action === "changePage") {
        handlePageChange(tableState.page);
      } else if (action === "changeRowsPerPage") {
        handleRowsPerPageChange({ target: { value: tableState.rowsPerPage } });
      }
    },
    selectableRows: false,
    downloadOptions: {
      filename: `Patient_list_${formattedDate}`,
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true,
      },
    },
    textLabels: {
      body: {
        noMatch: loading ? "Loading patients..." : "No patients found",
      },
    },
    customToolbar: () => {
      return (
        <>
          <IconButton onClick={handleDownloadCSV} title="Download CSV">
            <GetAppIcon />
          </IconButton>
          <IconButton onClick={handlePrint} title="Print">
            <PrintIcon />
          </IconButton>
        </>
      );
    },
  };

  const currentDomain = window.location.hostname;
  return (
    <>
      <Helmet>
        <title>
          Patient Records System | {currentDomain} | Hospital Management
          Software | Smart Solutions for Hospital Efficiency
        </title>
      </Helmet>
      <NavLink to="/newpatientregistration">
        <button
          className="btn btn-success btn-sm mr-2"
          style={{ margin: "10px" }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="18"
            style={{ paddingRight: "4px" }}
            viewBox="0 0 100 100"
          >
            <line
              x1="10"
              y1="50"
              x2="90"
              y2="50"
              stroke="white"
              strokeWidth="10"
            />
            <line
              x1="50"
              y1="10"
              x2="50"
              y2="90"
              stroke="white"
              strokeWidth="10"
            />
          </svg>
          New Patient
        </button>
      </NavLink>
      <MUIDataTable
        title={"Patient List"}
        data={filteredData}
        columns={columns}
        options={options}
        className="custom-mui-datatable"
      />
    </>
  );
};

export default ListViewBed;
